import { Controller } from "stimulus";

// A select2 whose options show the address behind each entry, not just its name.
// Address books hold entries with near-identical names ("Warehouse", "Office"),
// so the name alone is not enough to pick the right one — and the detail is
// wanted while choosing rather than after saving.
//
// Each <option> carries the detail in data attributes:
//   data-line        one-line address, e.g. "Vasteland 100, 3011 BP Rotterdam, NL"
//   data-identifiers labelled identifiers, e.g. "EORI NL123456789   VAT NL813..."
export default class extends Controller {
  connect() {
    const placeholder = this.element.dataset.placeholder;

    const config = {
      width: "100%",
      allowClear: Boolean(placeholder),
      templateResult: (data) => this.optionMarkup(data),
      templateSelection: (data) => data.text,
    };

    // Only set placeholder when there is one. select2 attaches HidePlaceholder
    // whenever the option is not null, and that strips every option whose value
    // is empty — so passing "" would silently remove a blank option the caller
    // put in the list on purpose, such as "no address".
    if (placeholder) config.placeholder = placeholder;

    // Inside a Bootstrap modal the dropdown has to be parented to the modal,
    // or the modal keeps focus and the search box cannot be typed into.
    const dropdownParent = this.element.dataset.dropdownParent;
    if (dropdownParent) config.dropdownParent = $(dropdownParent);

    $(this.element)
      .select2(config)
      .on("select2:select select2:unselect select2:clear", () => {
        this.element.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }

  // Tear the select2 instance down with the element, so the widget it appends to
  // the modal and its handlers do not outlive the controller.
  disconnect() {
    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).select2("destroy");
    }
  }

  // Two or three lines per option: the name, then what it stands for.
  // Falls back to the plain name for the blank option and while searching.
  optionMarkup(data) {
    if (!data.element) return data.text;

    const { line, identifiers } = data.element.dataset;
    if (!line && !identifiers) return data.text;

    const wrapper = document.createElement("div");
    wrapper.appendChild(this.line(data.text));
    if (line) wrapper.appendChild(this.line(line, "small text-muted"));
    if (identifiers) wrapper.appendChild(this.line(identifiers, "small text-muted"));

    return $(wrapper);
  }

  // textContent, never innerHTML: address names and streets are customer data
  // and select2 does not escape markup returned from a template.
  line(text, className) {
    const element = document.createElement("div");
    if (className) element.className = className;
    element.textContent = text;

    return element;
  }
}
